export default function Testimonials() {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      role: 'Homeowner, Westbrook',
      image: 'https://public.readdy.ai/ai/img_res/908aecea8d3f504f43c07979382ff714.jpg',
      rating: 5,
      text: 'Ecomez transforms my home every week! The team is punctual, professional and uses eco-friendly products. I highly recommend their cleaning services in Westbrook.'
    },
    {
      name: 'Michael Davis',
      role: 'Office Manager, Portland',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20male%20business%20manager%20in%20his%20fifties%20with%20confident%20smile%20in%20modern%20office%20setting%2C%20natural%20lighting%2C%20professional%20businessman%20with%20gray%20hair%20wearing%20business%20casual%20attire%2C%20happy%20customer%20testimonial%20photo%2C%20realistic%20portrait%20photography&width=200&height=200&seq=testimonial-002&orientation=squarish',
      rating: 5,
      text: 'We have been using Ecomez for office cleaning for 2 years. Impeccable service, reliable team and competitive rates. Our Portland offices are always spotless.'
    },
    {
      name: 'Emily Wilson',
      role: 'Restaurant Owner, Westbrook',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20female%20restaurant%20owner%20in%20her%20thirties%20with%20bright%20smile%20in%20clean%20commercial%20kitchen%2C%20natural%20lighting%2C%20friendly%20businesswoman%20with%20blonde%20hair%20wearing%20chef%20coat%2C%20happy%20customer%20testimonial%20photo%2C%20realistic%20portrait%20photography&width=200&height=200&seq=testimonial-003&orientation=squarish',
      rating: 5,
      text: 'For my restaurant, I need impeccable cleaning service. Ecomez perfectly meets my expectations with regular interventions and quality work.'
    },
    {
      name: 'Robert Anderson',
      role: 'Property Owner, Portland',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20male%20property%20owner%20in%20his%20forties%20with%20friendly%20smile%20standing%20in%20clean%20modern%20apartment%2C%20natural%20lighting%2C%20professional%20real%20estate%20owner%20with%20dark%20hair%20wearing%20casual%20business%20attire%2C%20happy%20customer%20testimonial%20photo%2C%20realistic%20portrait%20photography&width=200&height=200&seq=testimonial-004&orientation=squarish',
      rating: 5,
      text: 'I manage several properties and Ecomez takes care of cleaning between tenants. Fast, efficient service and reasonable prices. Perfect for one-time interventions in Portland.'
    },
    {
      name: 'Jennifer Martinez',
      role: 'Shop Manager, Westbrook',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20female%20shop%20manager%20in%20her%20thirties%20with%20warm%20smile%20in%20clean%20retail%20store%2C%20natural%20lighting%2C%20friendly%20businesswoman%20with%20red%20hair%20wearing%20professional%20attire%2C%20happy%20customer%20testimonial%20photo%2C%20realistic%20portrait%20photography&width=200&height=200&seq=testimonial-005&orientation=squarish',
      rating: 5,
      text: 'My shop is always spotless thanks to Ecomez. The team is discreet, efficient and perfectly respects our opening hours. Professional cleaning service in Westbrook.'
    },
    {
      name: 'David Thompson',
      role: 'Entrepreneur, Portland',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20male%20entrepreneur%20in%20his%20thirties%20with%20confident%20smile%20in%20modern%20clean%20office%20space%2C%20natural%20lighting%2C%20professional%20businessman%20with%20short%20dark%20hair%20wearing%20business%20shirt%2C%20happy%20customer%20testimonial%20photo%2C%20realistic%20portrait%20photography&width=200&height=200&seq=testimonial-006&orientation=squarish',
      rating: 5,
      text: 'Excellent value for money! Ecomez offers complete cleaning service for our small business. Friendly team and careful work. I recommend without hesitation.'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            What Our <strong>Clients</strong> Say
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover reviews from our satisfied clients in <strong>Westbrook and Portland</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top"
                />
                <div>
                  <h5 className="font-bold text-gray-900">{testimonial.name}</h5>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
